import { render } from "./AddToHomeScreen.vue?vue&type=template&id=95efcc10&scoped=true&bindings={}"
import script from "./AddToHomeScreen.vue?vue&type=script&lang=ts"
export * from "./AddToHomeScreen.vue?vue&type=script&lang=ts"

import "./AddToHomeScreen.vue?vue&type=style&index=0&id=95efcc10&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-95efcc10"

export default script